import { configureStore } from "@reduxjs/toolkit";
import cartSlice from "../Features/Cart/cartSlice";
import wishListSlice from "../Features/Wishlist/wishListSlice";
import userSlice from "../Features/User/UserSlice.js";
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { combineReducers } from "redux";

// Configuration for redux-persist
const persistConfig = {
  key: 'root', // Root key for storage
  storage,     // Use localStorage for persistence
  whitelist: ['user', 'cart'], // Only persist the 'user' and 'cart' slices
};

// Combine reducers
const rootReducer = combineReducers({
  user: userSlice,
  cart: cartSlice,
  wishlist: wishListSlice,
});

// Create persisted reducer
const persistedReducer = persistReducer(persistConfig, rootReducer);

// Configure the store
const store = configureStore({
  reducer: persistedReducer, // Use the persisted reducer here
});

// Export persistor and store
export const persistor = persistStore(store);
export default store;
